import type { DataZone, DataZoneLowerCaseString } from '@/entities/quality';

export const formatDataZone = (dataZone: DataZoneLowerCaseString): DataZone => {
  const dataZoneMap: Record<DataZoneLowerCaseString, DataZone> = {
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
  };
  return dataZoneMap[dataZone] || 'Bronze';
};
